import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL.replace('internal-', '')

export default class Sms {
  constructor(token) {
    axios.defaults.baseURL = API_URL + '/v1/notifications/'
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  }

  getPhoneNumber(source, userId) {
    const params = userId ? `?source=${source}&user_id=${userId}` : ''
    return axios
      .get('/receiver' + params)
      .then((response) => response.data)
      .catch((error) => error.response)
  }

  sendCode(data) {
    return axios
      .post('/authentication', data)
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  }

  checkCode(data) {
    return axios
      .put('/authentication', data)
      .then((response) => response.data)
      .catch((error) => error.response)
  }
}
